import * as yup from "yup";
import { text as textSchema, number as numberSchema, signature as signatureSchema } from "../schemas";
import _ from "lodash";

const doctorValidations = {
  name: textSchema,
  surname: textSchema,
  documentNumber: numberSchema,
  licenseType: textSchema
    .default("nacional"),
  licenseNumber: numberSchema,
  // No `title`: api derives it from gender, and later from the SISA profession. A title default
  // here would be submitted even without a field on screen (react-hook-form sends defaultValues).
  gender: textSchema
    .oneOf(["f", "m", "o"], "Este campo es obligatorio"),
  specialty: yup.string()
    .required("")
    .default(""),
  workPhone: textSchema,
  address: textSchema,
  province: textSchema,
  signature: signatureSchema,
};

export default doctorValidations;